import { format as fnsFormat } from 'date-fns';
import { ja } from 'date-fns/locale';
import parse from 'date-fns/parse';

export function format(date: Date | number, formatStr: string): string {
  return fnsFormat(date, formatStr, {
    locale: ja,
  });
}

export function yearMonthFormat(dateString: string): string {
  const month = parse(format(new Date(dateString), 'yyyy-MM').toString(), 'yyyy-MM', new Date());

  return format(month, 'yyyy年MM月');
}

export function dateParser(date: string): Date {
  return parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
}

export function dateParserHHmm(date: string): Date {
  return parse(date, 'HH:mm', new Date());
}

// [35jzcn4] tenant tool unified date format
export const TT_DATE_FORMAT = 'yyyy年MM月dd日(EE)';
